export default "__VITE_ASSET__ccc272eb__"